import OfficeApplicationSupportImplementation from './implementation/OfficeApplicationSupportImplementation';
var OfficeApplicationSupportComponent = OfficeApplicationSupportImplementation;
export default OfficeApplicationSupportComponent;
//# sourceMappingURL=OfficeApplicationSupportComponent.js.map